export default function menuToggle() {
  const navBtn = jQuery('#navBtn');
  const closeBtn = jQuery('#closeBtn');
  const menu = jQuery('#navbarNav');

  navBtn.on('click', function () {
      closeBtn.fadeIn('slow');
      menu.removeClass('translate-x-full');
  });

  closeBtn.on('click', function () {
      navBtn.fadeIn('slow');
      menu.addClass('translate-x-full');
  });
}
